import React, { useState } from "react";
import { Select, TextField } from "../../Form/Fields";
import CREATE_ACCOUNT_SCHEMA from "./create-account-schema";
import clxs from "./create-account.module.css";
import Form from "../../Form";
import Button from "../../Button";
import usePhoneExts from "../../../hooks/use-phone-exts";
import useClx from "../../../hooks/use-clx";
import useUserService from "../../../hooks/use-user-service";

interface CreateAccountProps {
  onSubmit: (value: any) => void;
  isConsentLogin?: boolean;
  reserve_booking_slug?: string;
}

function CreateAccount (props: CreateAccountProps) {
  const phoneExts = usePhoneExts(),
  pcx = useClx(clxs.phoneNo , "phone-no"),
    { service: userService } = useUserService(),
    { onSubmit, isConsentLogin, reserve_booking_slug } = props,
    [errorMessage, setErrorMessage] = useState<string>(""),
    /**
     * Handles form submission for consent ; rest working same as normal login
     */
    handleSubmit = async (values: any) => {
      if (isConsentLogin && reserve_booking_slug) {
        const { phone_ext, phone_no } = values;
        if (!phone_ext || !phone_no) {
          return;
        }

        const { error, response } = await userService.concentFormCheck(reserve_booking_slug, phone_ext, phone_no);

        if (error) {
          setErrorMessage(error.message);
          return;
        } else if (response && onSubmit) {
          onSubmit(values);
          return;
        }
      } else {
        onSubmit(values);
      }

    };

  return (
    <>
      <div className={clxs.title}>
        {isConsentLogin ? "Welcome to LohonoStays!" : "Login / Create Account"}
        <div className={clxs.subTitle}>
          Enter your phone number to continue
        </div>
      </div>
      <Form
        id={FORM_ID}
        defaultValue={DEFAULT_VALUE}
        onSubmit={handleSubmit}
        className={clxs.formContainer}
        validationSchema={CREATE_ACCOUNT_SCHEMA}
      >
        <div className={clxs.phoneContainer}>
          <Select
            form={FORM_ID}
            name="phone_ext"
            options={phoneExts}
            // label="Phone code *"
          />
          <TextField
            form={FORM_ID}
            name="phone_no"
            className={useClx(pcx, errorMessage && clxs.errorInput)}
            // label="Phone number *"
            placeholder="Phone number *"
          />
        </div>
        {errorMessage && <div className={clxs.errorMessage}>{errorMessage}</div>}
        <Button
          form={FORM_ID}
          type="submit"
          className={clxs.sendOtpButton}
        >
          Send Otp
        </Button>
      </Form>
    </>
  );
}

export default CreateAccount;

const FORM_ID = "create-account";

const DEFAULT_VALUE = {
  phone_ext: "+91",
  phone_no: "",
};

